import React from 'react';
import './style.css';




const PageSlap = () => {
  

  return (
    <>
      <div id="container-page-slap">
        <h1>PAGINA DE SLAP EM CONSTRUÇÃO</h1>

       
      </div>
    </>
  )
}

export default PageSlap